import React from 'react'
import PropTypes from 'prop-types'
import { LinearProgress, createTheme, ThemeProvider } from '@mui/material'

export function ProgressBar(props) {
  const theme = createTheme({
    palette: {
      primary: {
        main: props.color,
      }
    }
  })

  return (
    <ThemeProvider theme={theme}>
      <LinearProgress variant={props.variant} value={props.value} color="primary" />
    </ThemeProvider>
  )
}

ProgressBar.propTypes = {
    variant: PropTypes.string,
    value: PropTypes.number,
    color: PropTypes.string,
}

ProgressBar.defaultProps = {
    variant: 'indeterminate',
    value: 10,
    color: '#EB1700',
}
